import { Checkbox } from "@repo/ui/Checkbox/checkbox";
import { FieldDescription } from "@repo/ui/field/fieldDescription";
import type { FC } from "react";

interface EndsCallFieldProps {
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

export const EndsCallField: FC<EndsCallFieldProps> = (props) => {
  const { isChecked, onChange } = props;

  return (
    <div>
      <Checkbox
        label="Transfers or ends the call"
        isChecked={isChecked}
        onChange={onChange}
      />
      <FieldDescription>
        Turn this on when this tool moves the caller elsewhere or hangs up, for
        example a transfer through your own phone system. The agent finishes
        speaking before the tool runs, and its part of the call ends once the
        tool succeeds. If the tool fails, the agent stays on the call.
      </FieldDescription>
    </div>
  );
};
